module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_meiosis_i_16-64d78e61d3ac52a5b561be4796d1d914.jpg";